import tncDistributor from "./distributor";
import legalPages from "./legalPages";
import tycPartner from "./partner";
import tycReferrer from "./referral";

const resources = {
  tycReferrer,
  tycPartner,
  tncDistributor,
  ...legalPages,
};

export default resources;
